var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgObsession = function SvgObsession(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.27 6.07A2.37 2.37 0 0 0 6 6.76",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.43 5v1.19H9.24v0M8.15 8.64A2.37 2.37 0 0 0 12.41 8",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 9.7V8.53h1.19v0",
    vectorEffect: "non-scaling-stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1.34 9.3a3.6 3.6 0 0 1 2.94-4.36 4.8 4.8 0 0 1 9.04-.4l.44-.14c1.5-.34 3 .6 3.35 2.1.35 1.52-.53 4.18-2.04 4.52 0 0-3.42.84-4.94 2.19-1.11.98-.96 2.43-2.34 3-.51.21-1.4.29-1.4.29L5.65 12a3.6 3.6 0 0 1-4.31-2.7Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgObsession;